export interface InfobipReportApiRecord {
  id: number;
  accountName: string;
  categoryCode: string;
  usageDate: string;
  billingTimeUnit: string | null;
  unitType: string;
  unitPrice: string;
  quantity: string;
  totalAmount: string;
  currency: string;
  countryCode: string | null;
  countryName: string | null;
  direction: string | null;
  networkName: string | null;
  trafficType: string | null;
}

export interface InfobipReportsResponse {
  totalRecords: number;
  reports: InfobipReportApiRecord[];
}

export interface ExactDecimal {
  coefficient: bigint;
  scale: number;
}

export interface InfobipReportRecord extends InfobipReportApiRecord {
  usageDay: string;
  service: string;
  country: string;
  operator: string;
  normalizedDirection: string;
  normalizedTrafficType: string;
  quantityValue: ExactDecimal;
  unitPriceValue: ExactDecimal;
  totalAmountValue: ExactDecimal;
}

export interface InfobipReportFilters {
  account: string | null;
  service: string | null;
  trafficType: string | null;
  direction: string | null;
  country: string | null;
  operator: string | null;
}

export interface InfobipFilterOption {
  label: string;
  value: string | null;
}

export interface InfobipFilterOptions {
  accounts: InfobipFilterOption[];
  services: InfobipFilterOption[];
  trafficTypes: InfobipFilterOption[];
  directions: InfobipFilterOption[];
  countries: InfobipFilterOption[];
  operators: InfobipFilterOption[];
}

export interface InfobipSummary {
  totalAmount: ExactDecimal;
  smsAmount: ExactDecimal;
  whatsappAmount: ExactDecimal;
  smsQuantity: ExactDecimal;
  whatsappQuantity: ExactDecimal;
  clientCount: number;
  recordCount: number;
}

export interface ClientBillingRow {
  accountName: string;
  smsQuantity: ExactDecimal;
  whatsappQuantity: ExactDecimal;
  smsAmount: ExactDecimal;
  whatsappAmount: ExactDecimal;
  totalAmount: ExactDecimal;
  details: InfobipReportRecord[];
}

export interface SmsBillingRow {
  accountName: string;
  country: string;
  operator: string;
  unitPrice: string;
  unitPriceValue: ExactDecimal;
  quantity: ExactDecimal;
  amount: ExactDecimal;
}

export interface WhatsappBillingRow extends SmsBillingRow {
  direction: string;
  trafficType: string;
}

export interface BillingSubtotal {
  accountName: string;
  trafficType?: string;
  quantity: ExactDecimal;
  amount: ExactDecimal;
}

export interface CountryOperatorRow {
  country: string;
  operator: string;
  service: string;
  unitType: string;
  quantity: ExactDecimal;
  amount: ExactDecimal;
}

export interface SpendPoint {
  key: string;
  label: string;
  amount: ExactDecimal;
}

export interface InfobipReportView {
  records: InfobipReportRecord[];
  summary: InfobipSummary;
  clients: ClientBillingRow[];
  smsRows: SmsBillingRow[];
  smsClientSubtotals: BillingSubtotal[];
  whatsappRows: WhatsappBillingRow[];
  whatsappTrafficSubtotals: BillingSubtotal[];
  whatsappClientSubtotals: BillingSubtotal[];
  countryOperatorRows: CountryOperatorRow[];
  dailySpend: SpendPoint[];
  serviceSpend: SpendPoint[];
  clientSpend: SpendPoint[];
}

export interface InfobipExportContext {
  filters: InfobipReportFilters;
  startDate?: string;
  endDate?: string;
  generatedAt: Date;
}

export interface InfobipValidationIssue {
  row: number;
  id?: number;
  field: string;
  value: unknown;
  message: string;
}

export class InfobipDataValidationError extends Error {
  constructor(public readonly issues: InfobipValidationIssue[]) {
    super(`Se encontraron ${issues.length} registros con datos inválidos.`);
    this.name = 'InfobipDataValidationError';
  }
}
